import { render } from "./rolelist.vue?vue&type=template&id=252290b2"
import script from "./rolelist.vue?vue&type=script&lang=js"
export * from "./rolelist.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__